// ** React Imports
import { createAction } from '@reduxjs/toolkit'

export const unauthorize = createAction('unauthorize')

export const authorize = createAction('authorize')
